import React from 'react';
import './Gallery.css';
import { Link } from 'react-router-dom';


const Gallery = () => {

  return (
    <>

      <section className="about">

<h2> Terms and Conditions - Application "Picky Walls"</h2> <br />

<p> Please read these terms and conditions carefully before using the "Picky Walls" ("Application") available on the Play Store platform. By downloading, accessing, or using this Application, you agree to and are bound by the following terms and conditions: <br /></p>


{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}


<h4>Usage of the Application</h4>

<p>a. The "Picky Walls" application is a mobile application that provides a downloadable image for your PERSONAL use only, like make it as a wallpaper, your personal project, or anything that doesnt affiliate with commercial issues.<br /> <br /> 

b. You are allowed to download and use this application on compatible devices, according to the system requirements specified by the Play Store.<br/> <br /> 

c. You are solely responsible for the use of this application and agree to comply with all applicable laws. <br />
</p>

{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}



<h4>Application Content</h4>

<p> a. This application presents list of downloadable image created by users and/or third parties.<br /> <br /> 

b. We reserve the right, without prior notice, to modify, delete, or add any content within this application.<br /></p>

{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}


<h4>Intellectual Property Ownership</h4>

<p>a. The "Picky Walls" application and all related intellectual property rights remain the property of ours or third parties who have granted us the license.<br /> <br />

b. You are not granted any rights or licenses to use or exploit the intellectual property rights contained in this application, unless otherwise stated in these terms and conditions..<br /> <br />

c. We are granting users the image , once again for PERSONAL USE only, and NOT FOR COMMERCIAL USE.<br />

d. If you think the image on this application is yours, but somehow you see on this app. you can contact and explain to us here : FinnEduDev@gmail.com , to modify and deleted the image. the request will be process in less than 3 days


</p>
{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}

<h4>User Privacy</h4>

<p>a. We respect user privacy. Information collected or accessed by this application will be handled in accordance with our Privacy Policy.<br /> <br/>

b. We are not responsible for any losses or information leaks caused by factors beyond our control, such as security breaches by third parties or misuse by users.<br /><br />

c. We also need to have data write allowed from users, so that how we can deliver every image to users gallery directly</p>

{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}


<h4>Limitation of Liability</h4>

<p> a. We are not responsible for any direct or indirect losses, damages, or claims arising from the use of this application.<br /> <br /> 

b. We do not provide any guarantees or warranties regarding the availability, accuracy, reliability, or performance of this application.<br /><br /></p>

{/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~` */}


<h4>Changes to Terms and Conditions</h4>

<p> a. We reserve the right to modify or update these terms and conditions according to our policies, without prior notice.<br /> <br />

b. You are obligated to check these terms and conditions periodically. Your use of the application after any changes to the terms and conditions implies that you accept and agree to those changes.<br /></p>

<h4>Termination of Use</h4>

<p>a. We reserve the right to terminate or suspend your use of this application if you violate these terms and conditions.<br /> <br />

b. We also have the right to terminate or suspend the operation of this application at any time without prior notice.<br /><br /></p>

<h4>Applicable Law</h4>

<p>a. These terms and conditions are governed and interpreted in accordance with the laws of our country (Indonesia).<br /> <br />

b. You agree that any dispute arising from or related to the use of this application will be exclusively resolved by the competent courts in our jurisdiction.<br /></p> <br></br>

<p className='special'> By using the "Picky WallS" application, you acknowledge and agree that you have read, understood, and consent to be bound by these terms and conditions. If you do not agree with these terms and conditions, please refrain from using this application.<br /><br />

Thank you for using the "Picky WallS" application! and have a nice day ^_^</p>
    </section>


    </>
  );
};


export default Gallery;